/* <radar-line>: la fascia di una linea si compone quando la si raggiunge.

   Senza JavaScript la fascia e' gia' tutta li' e si legge: la classe che
   nasconde i pezzi la mette il JavaScript stesso (is-armed), quindi se questo
   file non arriva - o il browser non ha IntersectionObserver - non resta una
   fascia vuota. E' il motivo per cui non basta scrivere
   "radar-line:not(.is-in)" nel CSS.

   E non la mette nemmeno al montaggio: la mette al primo giro
   dell'osservatore, cioe' solo dopo aver saputo che l'osservatore c'e' e
   parla. Prima si nascondeva subito e una rete a 1200ms rimediava mostrando
   la fascia comunque - ma la rete non guardava dove fosse, e su /collections
   la fascia sta sotto due righe di schede: l'animazione si consumava al
   caricamento, lontano dagli occhi, e arrivati li' scorrendo era gia'
   finita. Poi ho provato a far scattare la rete solo se l'osservatore era
   rimasto zitto: non basta, perche' in una scheda aperta in secondo piano
   Chrome ferma il disegno e con lui l'osservatore, che allora sembra rotto e
   invece sta solo aspettando il suo turno. Senza rete il problema non si
   pone: se l'osservatore non parla, la fascia non si nasconde.

   Se al primo giro la fascia e' gia' in schermo non si nasconde e non si
   anima: non c'e' nessun arrivo da accompagnare, si e' gia' li'.

   La soglia e' bassa apposta. La fascia e' alta ~420px e su un telefono ne
   entra in schermo poco per volta: una soglia alta non scatterebbe mai, ed e'
   un errore gia' fatto altrove in questo tema. Il margine negativo in fondo
   le toglie l'ultima fetta di schermo: senza, la fascia parte quando spunta
   appena dal bordo inferiore e l'animazione la si guarda di sbieco. */
(function (global) {
  'use strict';

  if (typeof HTMLElement !== 'function') return;

  var RadarLine = class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;

      var reduced = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced && reduced.matches) return;
      if (!('IntersectionObserver' in global)) return;

      this.watcher = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            this.reveal();
            return;
          }
          // Fuori schermo, e l'osservatore ha appena dimostrato di
          // funzionare: solo ora si possono nascondere i pezzi, perche' da
          // qui in poi qualcuno sa riaccenderli.
          this.classList.add('is-armed');
        }.bind(this),
        { threshold: 0.2, rootMargin: '0px 0px -12% 0px' },
      );
      this.watcher.observe(this);
    }

    disconnectedCallback() {
      if (this.watcher) this.watcher.disconnect();
      this.watcher = null;
    }

    reveal() {
      if (this.revealed) return;
      this.revealed = true;
      if (this.watcher) this.watcher.disconnect();
      this.classList.add('is-in');
    }
  };

  if (!customElements.get('radar-line')) customElements.define('radar-line', RadarLine);
})(typeof window !== 'undefined' ? window : globalThis);
